export default "__VITE_ASSET__CwA_hLev__"